<template>
  <div>
    <b-row>
      <SearchOpts
        v-model="temp.imagen"
        :searchService="searchImagenesByEstablecimiento"
        :placeholder="'Buscar imágen...'"
        :minChars="3"
        class="col"
      />
    </b-row>

    <div v-if="temp.imagen" class="my-2">
      <b-row  v-if="esOdontologia" class="my-1 d-flex align-items-center">
        <label class="col-2">Diagnostico</label>
        <b-col cols="9">
          <SearchOpts
            v-model="searchDiagnostico"
            :searchService="diagnosticosService.getByQuerySelect"
            :minChars="3"
            :placeholder="'Buscar diagnostico...'"
            class="form-control-sm"

          />
        </b-col>

      </b-row>

      <b-row class="my-1 d-flex align-items-center">
        <label class="col-2">Lateralidad</label>
        <v-select
          class="col-4"
          id="v-lateralidad"
          v-model="temp.lateralidad"
          :options="optsLateridades"
          label="text"
        />

        <div class="d-flex align-items-center ml-3">
          <label for="">Requiere sedación?</label>
          <b-form-checkbox switch v-model="temp.sedacion" class="mx-2" />
        </div>
      </b-row>

      <b-row v-if="esIess">
        <label class="col-2">Número de Orden AS400</label>
        <validation-provider #default="{ errors }" name="norden" class="col-6">
          <b-form-input
            id="v-norden"
            :state="errors.length > 0 ? false : null"
            v-model="temp.numeroOrden"
            type="number"
            @keypress="validateKeyPress('norden', $event)"
          />
        </validation-provider>
      </b-row>

      <b-row class="my-1 d-flex align-items-center">
        <label class="col-2">Motivo de Solicitud</label>
        <b-form-textarea
          class="col mx-1"
          v-model="temp.motivoSolicitud"
          placeholder="Escriba el motivo de la solicitud..."
          rows="2"
          no-resize
        />
      </b-row>
      <b-row v-if="esOdontologia" class="my-1 d-flex align-items-center">
        <label class="col-2">Numero de Pieza</label>
        <b-form-textarea
          class="col mx-1"
          v-model="temp.numeroPieza"
          placeholder="Escriba el numero de Pieza..."
          rows="1"
          no-resize
        />
      </b-row>

      <b-row class="my-1 d-flex align-items-center">
        <label class="col-2">Resumen Clínico</label>
        <b-form-textarea
          class="col mx-1"
          v-model="temp.resumenClinico"
          placeholder="Escriba el resumen clínico..."
          rows="2"
          no-resize
        />
      </b-row>

      <b-row
        class="my-1 d-flex align-items-center"
        v-if="tempImagenRepetida || temp.justificacion"
      >
        <label class="col-2">Justificacion</label>
        <b-form-textarea
          class="col mx-1"
          v-model="temp.justificacion"
          placeholder="Escriba la justificación..."
          rows="2"
          no-resize
        />
      </b-row>

      <b-row class="my-2 d-flex justify-content-end">
        <b-button
          v-if="!indexToEdit"
          variant="info"
          size="sm"
          @click="agregarImagen"
          style="cursor: pointer"
          class="mx-1"
        >
          <i class="fas fa-solid fa-plus" title="Agregar Diagnostico" />
          Agregar
        </b-button>

        <b-button
          v-if="indexToEdit"
          variant="info"
          size="sm"
          @click="editarImagen()"
          style="cursor: pointer"
        >
          Guardar
        </b-button>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SearchOpts } from "@/shared/components";
import { ValidationProvider } from "vee-validate";
import vSelect from "vue-select";
import { getEstablecimientoLS } from "@/shared/helpers";
import {
  carteraImagenService,
  getLateralidadesImagen,
} from "@/views/imagen/services";
import { diagnosticosService } from "../../../atencionMedica/services";
import { watch } from "vue";

export default {
  name: "FormAddImagen",

  props: {
    imagenesList: {
      type: Array,
      required: true,
    },

    esIess: {
      type: Boolean,
      default: false,
    },

    indexToEdit: {
      type: String,
      default: null,
    },
  },

  components: {
    vSelect,
    SearchOpts,
    ValidationProvider,
  },




  created() {
    this.loadDataFields();

    if (this.indexToEdit !== null) this.loadDataToEdit();
  },

  data() {
    return {
      diagnosticosService,
      optsLateridades: [],
      tempImagenRepetida: false,
      searchDiagnostico: null,

      temp: {
        imagen: null,
        numeroPieza: "",
        lateralidad: null,
        sedacion: false,
        numeroOrden: null,
        motivoSolicitud: "",
        resumenClinico: "",
        justificacion: "",
        diagnostico: null,
        textDiagnostico: null,
       
      },
    };
  },

  computed: {
    ...mapState({
      stDataDoctor: (state) => state.atencionCita.dataCita?.doctor,
    }),

    esOdontologia() {
      return this.stDataDoctor?.especialidad?.codEsp === "0000000134";
    },
  },

  watch: {

    'temp.numeroPieza': {
    handler(newValue) {
      this.temp.motivoSolicitud  = this.mergeNumeroPiezaEnTexto(this.temp.motivoSolicitud, newValue);
      this.temp.resumenClinico   = this.mergeNumeroPiezaEnTexto(this.temp.resumenClinico, newValue);
    },
    immediate: false,
  },
    indexToEdit: {
      handler() {
        if (this.indexToEdit !== null) this.loadDataToEdit();
      },
    },

    imagenesList: {
      handler() {
        if (this.indexToEdit !== null) this.loadDataToEdit();
      },
      deep: true,
    },
    searchDiagnostico: {
      deep:true,
      handler(newValue){
        if(newValue){
          this.agregarDiagnostico()
        }else if(!newValue) {
          this.deleteTempDiagnostico()
        } 
      }
    }
    
  },


  methods: {
    deleteTempDiagnostico() {
      this.temp.diagnostico = null;
      this.textDiagnostico = null;
    },
    agregarDiagnostico() {
      this.temp.diagnostico = this.searchDiagnostico.value;
      this.temp.textDiagnostico = this.searchDiagnostico.text;
    },

    mergeNumeroPiezaEnTexto(texto = "", numeroPieza) {
      const baseTexto = (texto || "").replace(/,?\s*Numero de Pieza:.*$/i, "").trim();
      const numero = (numeroPieza ?? "").toString().trim();
      if (!numero) return baseTexto;
      const separador = baseTexto ? ", " : "";
      return `${baseTexto}${separador}Numero de Pieza: ${numero}`;
    },

    extraerNumeroPieza(texto = "") {
      const match = texto.match(/Numero de Pieza:\s*([^\n,]+)/i);
      return match ? match[1].trim() : "";
    },

    async loadDataFields() {
      this.optsLateridades = await getLateralidadesImagen();
    },

    generateCodeDate() {
      return new Date().getTime().toString();
    },

    async agregarImagen() {
      if (!this.esIess) this.temp.numeroOrden = this.generateCodeDate();

      if (
        !this.temp.imagen ||
        !this.temp.numeroOrden ||
        !this.temp.lateralidad ||
        !this.temp.motivoSolicitud ||
        !this.temp.resumenClinico
      ) {
        await this.$swal({
          title: "Error",
          text: "Por favor, complete todos los campos requeridos antes de agregar la imagen.",
          icon: "error",
          confirmButtonText: "Ok",
        });

        return;
      }

      const hayOrdenRepetida = this.validateOrdenRepetida();
      if (hayOrdenRepetida) return;

      const hayImagenRepetida = this.validateImagenRepetida();
      if (hayImagenRepetida) return;

      const nuevaImagen = {
        ...this.temp,
        sedacion: this.temp.sedacion ? "1" : "2",
        action: "crear",
      };

      this.imagenesList.splice(this.imagenesList.length, 0, nuevaImagen);
      this.limpiarFormulario();
    },

    validateOrdenRepetida() {
      const ordenRepetida = this.imagenesList.findIndex(
        (i) => i.numeroOrden === this.temp.numeroOrden
      );

      if (this.indexToEdit) {
        if (this.indexToEdit == ordenRepetida) return false;
      }

      if (ordenRepetida !== -1) {
        this.$swal({
          title: "Orden Repetida",
          text: `La orden <<${this.temp.numeroOrden}>> ya se encuentra en la lista de procesos. Debera ingresar un numero de orden diferente.`,
          icon: "warning",
          confirmButtonText: "OK",
        });

        return true;
      }

      return false;
    },

    validateImagenRepetida() {
      const imagenRepetida = this.imagenesList.find(
        (i) => i.imagen.value === this.temp.imagen.value
      );

      const indexImagenRepetida = this.imagenesList.findIndex(
        (i) => i.imagen.value === this.temp.imagen.value
      );

      if (this.indexToEdit) {
        if (this.indexToEdit == indexImagenRepetida) return false;
      }

      this.tempImagenRepetida = imagenRepetida;

      if (imagenRepetida && !this.temp.justificacion) {
        this.$swal({
          title: "Imagen ya agregada",
          text: `La imagen <<${imagenRepetida.imagen.text}>> ya fue agregada, debera ingresar una justificacion`,
          icon: "warning",
          confirmButtonText: "Ok",
        });
      }

      return imagenRepetida && !this.temp.justificacion;
    },

    validateKeyPress(campo, event) {
      if (
        campo === "norden" &&
        this.temp.numeroOrden?.length >= 10 &&
        !["Backspace", "ArrowLeft", "ArrowRight"].includes(event.key)
      ) {
        event.preventDefault();
      }
    },

    limpiarFormulario() {
      this.tempImagenRepetida = false;
      this.temp = {
        imagen: null,
        lateralidad: null,
        numeroPieza: "",
        numeroOrden: null,
        motivoSolicitud: "",
        resumenClinico: "",
        sedacion: null,
        justificacion: "",
      };
    },

    async searchImagenesByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();

      const params = {
        search,
        establecimiento: establecimiento.id,
      };

      const response = await carteraImagenService.getAll(params);
      if (!response) return [];

      const dataSelect = response.imagenes.map((i) => ({
        value: i.id,
        text: `(${i.codigo}) ${i.nombre}`,
        nombre: i.nombre,
        codigo: i.codigo,
      }));

      return dataSelect;
    },

    loadDataToEdit() {
      const index = Number(this.indexToEdit);
      const imagenToEdit = this.imagenesList?.[index];
      if (!imagenToEdit) return;

      const imagenToEditCopy = { ...imagenToEdit };
      imagenToEditCopy.sedacion = imagenToEditCopy.sedacion === "1";
      const numeroPiezaDetectado = imagenToEditCopy.numeroPieza
        || this.extraerNumeroPieza(imagenToEditCopy.motivoSolicitud)
        || this.extraerNumeroPieza(imagenToEditCopy.resumenClinico);
      imagenToEditCopy.numeroPieza = numeroPiezaDetectado;

      this.temp = imagenToEditCopy;
    },

    editarImagen() {
      const hayOrdenRepetida = this.validateOrdenRepetida();
      if (hayOrdenRepetida) return;

      const hayImagenRepetida = this.validateImagenRepetida();
      if (hayImagenRepetida) return;

      const imagenEditada = {
        ...this.temp,
        action: this.temp.action !== "crear" ? "editar" : "crear",
        sedacion: this.temp.sedacion ? "1" : "2",
      };

      this.$set(this.imagenesList, this.indexToEdit, imagenEditada);
      this.$emit("closeModal");
      this.limpiarFormulario();
    },
  },
};
</script>
